import React from 'react';
import AppContent from './AppContent';

export default function App() {
  return <AppContent />;
}
